import { render, staticRenderFns } from "./LabelTag.vue?vue&type=template&id=51f83eec&scoped=true"
import script from "./LabelTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelTag.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LabelTag.vue?vue&type=style&index=0&id=51f83eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.2.47_babel-core@7.0.0-bridge.0_@babel+core@7.20.12__cs_dsp4ve4m4u4ggk2pimednah2wa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f83eec",
  null
  
)

export default component.exports